export default {
  loading: (state, payload) => (state.loading = payload),
  notice: (state, payload) => (state.notice = payload),
  acted: state => (state.acted = !state.acted),
  referer: (state, payload) => (state.referer = payload),
  setIsDemo: (state, payload) => (state.demo.isDemo = payload),
  setLock: (state, payload) => (state.isLocked = payload),
}
